import LoadAdobeScript from "@tm/insurance/analytics/loadAdobeScript";
import {
  GIHeaderProps,
  GIInsuranceHeader,
} from "../static/components/GIInsuranceHeader";

interface GIInsuranceHeaderPropsWithWrapper extends GIHeaderProps {
  Wrapper?: (props: { children: JSX.Element[] }) => JSX.Element;
  forceLogin?: boolean;
  isLoadScript?: boolean;
}

export function withGIInsuranceHeader(
  component: JSX.Element,
  headerOptions: GIInsuranceHeaderPropsWithWrapper = {},
  mobileTitle = "",
  myOrders = false,
  goToMyOrders = () => void 0,
  displayWhiteHeader = false,
  showPwaHeaderBackButton = true,
  onLoginSuccess = () => void 0
) {
  const {
    Wrapper,
    forceLogin = false,
    isLoadScript = false,
    ...headerProps
  } = headerOptions;
  const giHeaderWithAuth = (
    <GIInsuranceHeader
      headerProps={headerProps}
      mobileTitle={mobileTitle}
      forceLogin={forceLogin}
      myOrders={myOrders}
      goToMyOrders={goToMyOrders}
      displayWhiteHeader={displayWhiteHeader}
      showPwaHeaderBackButton={showPwaHeaderBackButton}
      onLoginSuccess={onLoginSuccess}
    />
  );

  if (forceLogin) {
    return giHeaderWithAuth;
  }
  if (Wrapper) {
    return (
      <Wrapper>
        <LoadAdobeScript partner="gi" isLoadScript={isLoadScript} />
        {giHeaderWithAuth}
        {component}
      </Wrapper>
    );
  }
  return (
    <>
      <LoadAdobeScript partner="gi" isLoadScript={isLoadScript} />
      {giHeaderWithAuth}
      {component}
    </>
  );
}
